import { Player, ResourceType } from "~/business";
import { typedFromEntries } from "~/utils";
import { XResourceType } from "./svg";
import { XResources } from "./XResources";

export const XPlayerResources = ({ player }: { player: Player }) => {
  const displayedResources = [
    ResourceType.Water,
    ResourceType.Spice,
    ResourceType.Solaris,
  ];
  const resources: [XResourceType, number][] = displayedResources.map(
    (resourceType) => [resourceType, player.getResource(resourceType)]
  );
  const resourceObject = typedFromEntries(resources);
  return <XResources resources={resourceObject} width={18} />;
};
